/* eslint-disable no-unused-vars */
export const DASHBOARD_FILTERS = {
	namespaced: true,
	state: {
		selectedfilters: {
			plant: [],
			pltName: [],
			funcLocation: [],
			code: [],
			insulation: [],
			cl: [],
			temperature: [],
			pressure: [],
		}
	},
	getters: {
		GET_FILTERS(state) {
			return state.selectedfilters;
		},
		GET_LOADING(state) {
			return state.loading;
		},
		GET_DEFAULT_FILTERS() {
			return {
				plant: [],
				pltName: [],
				funcLocation: [],
				code: [],
				insulation: [],
				cl: [],
				temperature: [],
				pressure: [],
			};
		}
	},
	mutations: {
		SET_FILTERS(state, value) {
			state.selectedfilters = value;
		},
		RESET_FILTERS(state) {
			state.selectedfilters = {
				plant: [],
				pltName: [],
				funcLocation: [],
				code: [],
				insulation: [],
				cl: [],
				temperature: [],
				pressure: [],
			};
		},
		SET_LOADING(state, value) {
			state.loading = value;
		}
	},
	actions: {
		RESET({ commit }) {
			commit('RESET_FILTERS');
		},
	}
}




